import React from "react";
import { DirectDebtPaymentMethodChangeFormData } from "src/schemas/DirectDebtFormSchema";
import { CONSTANTS_STRINGS } from "src/constants";
import { Edit } from "lucide-react";
import InfoItem from "./InfoItem";

interface BankAccountInfoProps {
  accountData: DirectDebtPaymentMethodChangeFormData;
  onEditClick: () => void;
}

const BankAccountInfo: React.FC<BankAccountInfoProps> = ({
  accountData,
  onEditClick,
}) => {
  return (
    <section aria-label="Informações bancárias">
      <ul className="flex list-none flex-col gap-2">
        <li className="flex items-center justify-between">
          <InfoItem
            label={CONSTANTS_STRINGS.DIRECT_DEBIT_FINANCIAL_INSTITUTION}
            value={accountData.bankData.name}
          />
        </li>
        <li className="flex items-center justify-between">
          <InfoItem
            label={CONSTANTS_STRINGS.DIRECT_DEBIT_AGENCY}
            value={accountData.agency}
          />
          <button
            onClick={onEditClick}
            className="text-secondary-2 rounded-sm p-1 text-sm font-medium hover:cursor-pointer focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none"
            aria-label={`${CONSTANTS_STRINGS.EDIT_ACCOUNT_BUTTON_ARIA_LABEL} - Agência: ${accountData.agency}`}
            type="button"
          >
            <Edit size={16} aria-hidden="true" />
          </button>
        </li>
        <li className="flex items-center justify-between">
          <InfoItem
            label={CONSTANTS_STRINGS.DIRECT_DEBIT_ACCOUNT}
            value={`${accountData.account} - ${accountData.digit}`}
          />
          <button
            onClick={onEditClick}
            className="text-secondary-2 rounded-sm p-1 text-sm font-medium hover:cursor-pointer focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none"
            aria-label={`${CONSTANTS_STRINGS.EDIT_ACCOUNT_BUTTON_ARIA_LABEL} - Conta: ${accountData.account}-${accountData.digit}`}
            type="button"
          >
            <Edit size={16} aria-hidden="true" />
          </button>
        </li>
      </ul>
    </section>
  );
};

export default BankAccountInfo;
